<div class="box"
     *ngIf="visible">

    <ng-container *ngIf="fieldtype=='date'">
        <span class="md-inputfield"
              [formGroup]="formGroup"
              *ngIf="!disabled">
            <p-calendar *ngIf="minDate"
                        [minDate]="minDate"
                        [yearRange]="yearRange"
                        [yearNavigator]="true"
                        [monthNavigator]="true"
                        dateFormat="dd/mm/yy"
                        selectionMode="single"
                        [formControl]="formControl"
                        [locale]="calendarLocal"
                        [showIcon]="true"
                        styleClass="bb-datepicker"></p-calendar>
            <p-calendar *ngIf="!minDate"
                        [yearRange]="yearRange"
                        [yearNavigator]="true"
                        [monthNavigator]="true"
                        dateFormat="dd/mm/yy"
                        selectionMode="single"
                        [formControl]="formControl"
                        [locale]="calendarLocal"
                        [showIcon]="true"
                        styleClass="bb-datepicker"></p-calendar>
            <label *ngIf="label">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>

    <ng-container *ngIf="fieldtype=='datetime'">
        <span class="md-inputfield"
              [formGroup]="formGroup"
              *ngIf="!disabled">
            <!--<p-calendar id="datetime" [yearRange]="yearRange" [yearNavigator]="true" monthNavigator="true" dateFormat="mm/dd/yy" showTime="true" placeholder="DateTime"></p-calendar>-->
            <p-calendar *ngIf="minDate"
                        [minDate]="minDate"
                        [showTime]="true"
                        [yearRange]="yearRange"
                        [yearNavigator]="true"
                        [monthNavigator]="true"
                        dateFormat="dd/mm/yy"
                        selectionMode="single"
                        [formControl]="formControl"
                        [locale]="calendarLocal"
                        [showIcon]="true"
                        styleClass="bb-datepicker"></p-calendar>
            <p-calendar *ngIf="!minDate"
                        [showTime]="true"
                        [yearRange]="yearRange"
                        [yearNavigator]="true"
                        [monthNavigator]="true"
                        dateFormat="dd/mm/yy"
                        selectionMode="single"
                        [formControl]="formControl"
                        [locale]="calendarLocal"
                        [showIcon]="true"
                        styleClass="bb-datepicker"></p-calendar>
            <label *ngIf="label">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="fieldtype=='multiselect'">
        <span class="md-inputfield-multiselect"
              *ngIf="!disabled">
            <p-multiSelect [style]="{width:'100%'}"
                           (onFocus)="focused=true;"
                           defaultLabel="Choisir"
                           [formControl]="formControl"
                           (onBlur)="focused=false;"
                           [options]="selectOptions"></p-multiSelect>
            <label class="multiselect-label"
                   for="{{label}}">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>

    <ng-container *ngIf="fieldtype=='select' || fieldtype=='gender'">
        <span class="md-inputfield"
              *ngIf="!disabled">
            <p-dropdown [filter]="withFilter"
                        [ngClass]="{'ui-inputwrapper-filled':object[name]||focused}"
                        (onFocus)="focused=true;"
                        [formControl]="formControl"
                        (onChange)="changeItem()"
                        (onBlur)="focused=false;"
                        [options]="selectOptions"
                        [style]="{width:'100%'}"></p-dropdown>
            <label for="{{label}}">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="fieldtype=='checkbox'">
        <span class="md-inputfield"
              *ngIf="!disabled">
            <p-inputSwitch [formControl]="formControl"
                           class="ui-inputwrapper-filled"></p-inputSwitch>
            <label *ngIf="label">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="fieldtype=='textarea'">
        <span class="md-inputfield"
              *ngIf="!disabled">
            <textarea [rows]="3"
                      pInputTextarea
                      [placeholder]="label"
                      style="width:100%;"
                      [formControl]="formControl"></textarea>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="fieldtype=='numeric'">
        <span class="md-inputfield"
              *ngIf="!disabled">
            <input type="text"
                   name="field"
                   [formControl]="formControl"
                   pattern="^[0-9]*\.?[0-9]*$"
                   pInputText>
            <label *ngIf="label">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="fieldtype=='input' || fieldtype=='firstname' || fieldtype=='lastname' || fieldtype=='email'">
        <span class="md-inputfield"
              *ngIf="!disabled">
            <input type="text"
                   pInputText
                   [placeholder]="placeholder"
                   [formControl]="formControl">
            <label *ngIf="label">{{label}}</label>
            <div *ngIf="!formControl.valid"
                 class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled"
                           name="name"
                           [value]="object[name]"
                           [label]="label"
                           [widths]="{}"
                           [fdef]="fdef"></app-display-field>
    </ng-container>


    <ng-container *ngIf="(fieldtype=='objects' || fieldtype=='href')">


        <ng-container *ngIf="fieldtype=='href' && hrefSelect == true">
            <div class="autocomplete"
                 *ngIf="!disabled">
                <!--TODO mettre le label dans l'autocomplete-->
                <div class="md-inputfield">
                    <label *ngIf="label">{{label}}</label>
                </div>
                <p-autoComplete [(ngModel)]="selectedItem"
                                [suggestions]="suggestionsItems"
                                [forceSelection]="false"
                                (completeMethod)="filterItems($event)"
                                field="object_preview"
                                [dropdown]="true"
                                (click)="changeItem()"
                                [multiple]="false">
                    <ng-template let-item
                                 pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:item,isbtn:false}"></ng-container>
                        </div>
                    </ng-template>
                </p-autoComplete>
                <div *ngIf="!formControl.valid"
                     class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
            </div>
            <app-display-field *ngIf="disabled"
                               name="name"
                               [value]="object[name]"
                               [label]="label"
                               [widths]="{}"
                               [fdef]="fdef"></app-display-field>
        </ng-container>

        <ng-container *ngIf="fieldtype=='href' && !hrefSelect">
            <div [ngClass]="disabled ? 'mt30' : ''">
                <button (click)="addItem()"
                        [disabled]="disabled"
                        pButton
                        icon="ui-icon-search"
                        class="btn-small"
                        [label]="label"></button>
                <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:object[name],isbtn:true}"></ng-container>
            </div>
        </ng-container>

        <ng-container *ngIf="fieldtype=='objects'">
            <div class="box">
                <div class="row between-xs middle-xs">
                    <div class="col-xs col-sm pTop pBottom"
                         *ngIf="!allowedClasses">
                        <button (click)="addItem()"
                                [disabled]="disabled"
                                pButton
                                icon="ui-icon-add"
                                class="btn-small"
                                label="Ajouter"></button>
                    </div>
                    <div *ngIf="allowedClasses">
                        <div *ngFor="let classe of allowedClasses"
                             class="col-xs-2 col-sm pTop pBottom">
                            <button (click)="addItem(classe)"
                                    [disabled]="disabled"
                                    pButton
                                    icon="ui-icon-add"
                                    class="btn-small"
                                    [label]="'Ajouter (' + classe + ')'"></button>
                        </div>
                    </div>
                </div>
            </div>

            <p-orderList [value]="object[name]"
                         [header]="label"
                         [responsive]="true"
                         [listStyle]="{height:'400px'}"
                         *ngIf="object && object[name] && orderable">
                <ng-template let-item
                             pTemplate="item"
                             let-index="index">
                    <div class="col-xs">
                        <div class="box"
                             style="clear: both;line-height: 2em;">
                            {{index + 1}})
                            <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:item,isbtn:false}"></ng-container>
                            <button (click)="deleteItem(index)"
                                    [disabled]="disabled"
                                    pButton
                                    icon="ui-icon-delete"
                                    class="btn-small red-btn fRight"></button>
                            <button (click)="editItem(index)"
                                    [disabled]="disabled"
                                    pButton
                                    icon="ui-icon-create"
                                    class="btn-small fRight"></button>
                        </div>
                    </div>
                </ng-template>
            </p-orderList>

            <div *ngIf="object && object[name] && !orderable">
                <div *ngFor="let item of object[name];let i = index; trackBy:trackItem"
                     class="row hoverableRow">
                    <div class="col-xs">
                        <div class="box">
                            <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:item,isbtn:false}"></ng-container>
                        </div>
                    </div>
                    <div class=""
                         style="width:60px;">
                        <div class="box">
                            <button (click)="editItem(i)"
                                    [disabled]="disabled"
                                    pButton
                                    icon="ui-icon-create"
                                    class="btn-small"></button>
                            <button (click)="deleteItem(i)"
                                    [disabled]="disabled"
                                    pButton
                                    icon="ui-icon-delete"
                                    class="btn-small red-btn"></button>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <p-dialog header="Recherche : {{placeholder}}"
                  [(visible)]="displaySearch"
                  [modal]="true"
                  showEffect="fade"
                  width="400">
            <div class="ui-fluid">
                <p-autoComplete [(ngModel)]="selectedItem"
                                [suggestions]="suggestionsItems"
                                (completeMethod)="filterItems($event)"
                                field="object_preview"
                        [dropdown]="true" [multiple]="multiple">
                    <ng-template let-item
                                 pTemplate="item">
                        <div class="ui-helper-clearfix">
                            <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:item,isbtn:false}"></ng-container>
                        </div>
                    </ng-template>
                    <ng-template let-item
                                 pTemplate="selectedItem">
                                <span>
                                    <ng-container *ngTemplateOutlet="itemTemplate;context:{obj:item,isbtn:false}"></ng-container>
                                </span>
                    </ng-template>
                </p-autoComplete>
            </div>
            <p-footer>
                <div class="ui-dialog-buttonpane ui-helper-clearfix">
                    <button type="button"
                            pButton
                            icon="fa-check"
                            [disabled]="disabled"
                            (click)="changeItem()"
                            label="Confirmer"></button>
                    <button type="button"
                            pButton
                            icon="fa-close"
                            (click)="displaySearch=false"
                            label="Annuler"></button>
                </div>
            </p-footer>
        </p-dialog>

    </ng-container>

    <ng-container *ngIf="fieldtype === 'wysiwyg'">
        <span class="md-inputfield" *ngIf="!disabled">
            <p-editor [style]="{height: '320px', width: '100%'}" [formControl]="formControl" [placeholder]="label"></p-editor>
            <div *ngIf="!formControl.valid" class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
        <app-display-field *ngIf="disabled" name="name" [value]="object[name]" [label]="label" [widths]="{}" [fdef]="fdef"></app-display-field>
    </ng-container>

    <ng-container *ngIf="fieldtype === 'image'">
        <app-display-field [value]="getFullImageUrl(object[name])" [label]="label" [widths]="{}" [fdef]="fdef"></app-display-field>
        <span class="md-inputfield" *ngIf="!disabled">
            <p-fileUpload name="Filedata[]" [customUpload]="true" (uploadHandler)="uploadFiles($event)" [auto]="true" chooseLabel="Ajouter"></p-fileUpload>
            <div *ngIf="!formControl.valid" class="ui-message ui-messages-error ui-corner-all">{{ errorMessages }}</div>
        </span>
    </ng-container>

</div>
